// @flow
import * as React from "react";
import Media from "react-media";
import styled, { css } from "styled-components";
import { withRouter, type RouterHistory } from "react-router-dom";
import ClickOutside from "../../common/ClickOutside";
import CloseIcon from "../../Icons/Close";
import { Fade } from "../../common/Animations";
import MobilePopup from "../../TradeMobile/Popup";

import * as S from "./styles";

export type PopupProps = {|
  in: boolean,
  onDismiss: (props?: any) => void
|};

type DesktopProps = {
  onDismiss: (props?: any) => void,
  style?: string | number,
  className?: string,
  children: React.Node,
  big?: boolean
};

function DesktopPopup({ style, onDismiss, className, children, big }: DesktopProps) {
  return (
    <S.Overlay style={style}>
      <ClickOutside onOutsideClick={onDismiss}>
        {({ innerRef }) => (
          <S.Popup big={big} ref={innerRef} className={className}>
            <S.CloseContainer onClick={onDismiss}>
              <CloseIcon />
            </S.CloseContainer>
            {children}
          </S.Popup>
        )}
      </ClickOutside>
    </S.Overlay>
  );
}

type Props = {
  ...PopupProps,
  className?: string,
  fades?: boolean,
  style?: string,
  children: React.Node,
  history: RouterHistory,
  big?: boolean
};

function StatelessPopup(props: Props) {
  const {
    children,
    className,
    in: inProp = true,
    style,
    fades = true,
    onDismiss
  } = props;


  return (
    <Media query="(min-width: 960px)">
      {matches =>
        matches ? (
          fades === true ? (
            <Fade in={inProp}>
              {/* перезаписываем style из пропсов */}
              {({ style }) => (
                <DesktopPopup
                  style={style}
                  className={className}
                  onDismiss={onDismiss}
                  big={props.big}
                >
                  {children}
                </DesktopPopup>
              )}
            </Fade>
          ) : (
            <DesktopPopup
              style={style}
              className={className}
              onDismiss={onDismiss}
            >
              {children}
            </DesktopPopup>
          )
        ) : (
          inProp === true && (
            <MobilePopup
              type="tournaments"
              onClick={onDismiss}
              title={null}
              className={className}
              nowrap={props.nowrap}
              mobileColumn={props.mobileColumn}
              big={props.big}
            >
              {children}
            </MobilePopup>
          )
        )
      }
    </Media>
  );
}

const Popup = withRouter(StatelessPopup);
export default Popup;

export const StyledPopup = styled(Popup)`
  @media (max-width: 959px) {
    display: flex;
    width: 100%;
    height: 100%;
    padding: 64px 16px;
    background-color: ${({ theme }) => theme.mainDark};
  }

  @media (min-width: 480px) and (max-width: 959px) {
    padding: 32px 16px;
  }
  
  @media (max-width: 959px) {
  ${({ full }) =>
    full &&
    css`
      padding:0;
    `};
  }
 
`;



// WEBPACK FOOTER //
// ./src/components/Tournaments/Popups/Popup.js